import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { ExchangePopup } from './exchange'
import { NewConnectionPopup } from './new_connection'
import { PullCalendarsPopup } from './pull_calendars'

export const PopupRoute = ({ isSettingsModalLayout = false }) => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.url}/new`} component={NewConnectionPopup} />
      <Route
        path={`${match.url}/exchange/new`}
        render={() => <ExchangePopup isSettingsModalLayout={isSettingsModalLayout} />}
      />
      <Route path={`${match.url}/pull/:id`} component={PullCalendarsPopup} />
    </Switch>
  )
}
